import { configureStore } from "@reduxjs/toolkit";
import generalReducer from "./app/general";
import stationsReducer from "./orm/stations";
import vehiclesReducer from "./orm/vehicles";
import userSessionReducer from "./orm/userSession";
import offersReducer from "./orm/offers";

export const store = configureStore({
  reducer: {
    general: generalReducer,
    stations: stationsReducer,
    vehicles: vehiclesReducer,
    userSession: userSessionReducer,
    offers: offersReducer,
  },
});

let saveTimeout: NodeJS.Timeout;

// store.subscribe(() => {
//   // Debounce um zu viele Writes zu vermeiden
//   clearTimeout(saveTimeout);
//   saveTimeout = setTimeout(() => {
//     try {
//       const state = store.getState().userSession;
//       const key = `ORM${process.env.NODE_ENV === "development" ? "_" + process.env.REACT_APP_DEPLOYCUSTOMERID : ""}_userSession`;

//       sessionStorage.setItem(key, JSON.stringify(state));
//     } catch (error) {
//       console.error("Error saving session to storage:", error);
//     }
//   }, 100);
// });

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
